import React, { useEffect, useState } from 'react'
import { func, number, object, oneOfType, string } from 'prop-types'
import styled from 'styled-components'
import RadioButton from '@taglivros/oef_componentes/build/components/radioButton'
import RadioGroup from '@taglivros/oef_componentes/build/components/radioGroup'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import CartaoCredito from '../../../components/CartaoCredito/CartaoCredito'
import CardAdicionar from '../../../components/CardAdicionar'
import CartaoCreditoForm from '../../../components/CartaoCreditoForm/CartaoCreditoForm'
import { useCartaoCredito } from '../../../contexts/CartaoCreditoContext'
import { useFluxosPagamento } from '../../../contexts/FluxosPagamentoContext'
import { ADICIONAR_NOVO_CARTAO, ID_ADICIONAR_NOVO_CARTAO, ID_RADIO_GROUP_PAGAMENTO_CARTAO, TITULO_ESCOLHA_CARTAO_CREDITO_EXISTENTE } from '../constantsFluxosPagamento'
import { isEmptyObject } from '../../../utils/helpers/helpers'
import SelecionaCartaoExistenteModal from './SelecionaCartaoExistenteModal'
import LabelVerCartoesCadastrados from './LabelVerCartoesCadastrados'
import { useGlobal } from '../../../contexts/GlobalContext'

const WrapperEscolhaCartoesExistentes = styled.div`
  align-self: baseline;

  #escolha-cartao {
    > div {
      align-self: baseline;
      width: 400px;
    }
    .children {
      width: 330px;
    }
    .radioLabel {
      padding-bottom: 15px;
    }
    display: grid;
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    grid-template-areas:
      "area1 area3"
      "area2 area2";

    .current-card {
      grid-area: area1;
      align-self: baseline;
    }

    .all-cards {
      grid-area: area2;
    }

    .new-card {
      grid-area: area3;
    }

    @media (max-width: ${StyleGuide.mediaQuery.tablet}) {
      grid-template-areas:
        "area1"
        "area2"
        "area3";
      & > div {
        width: 280px;
        @media (max-width: 320px) {
          width: 95%;
        }
      }
      .children {
        width: 280px;
        @media (max-width: 320px) {
          width: 95%;
        }
      }
    }

    .radioLabel {
      margin: 5px 0;

      > div {
        border-color: ${( { tema } ) => tema} !important;
        &::after {
          background: ${( { tema } ) => tema} !important;
        }
      }
    }
  }
`

const WrapperCartaoCreditoVigente = styled.div`
  opacity: ${( { ativo } ) => ativo ? '1' : '0.3'};
`

const EscolhaCartoesExistentes = ( { idCartaoDeCreditoSelecionado = null, setNovoCartaoCredito, setIdCartaoDeCreditoSelecionado } ) => {
  const { temaFluxo, etapaAtiva, setarErrosDadosEtapas } = useFluxosPagamento()
  const {
    cartaoVigente,
    cartoesCadastrados,
    loading,
    showAllCreditCards,
    setShowAllCreditCards
  } = useCartaoCredito()
  const [ openFormulario, setOpenFormulario ] = useState( false )
  const [ cartaoExistente, setCartaoExistente ] = useState( {} )
  const [ selecionaCartaoExistente, setSelecionaCartaoExistente ] = useState( {} )
  const { captcha, setValidCaptcha, setCaptcha } = useGlobal()

  useEffect( () => {
    if ( idCartaoDeCreditoSelecionado !== null ) {
      const cartaoSelecioado = cartoesCadastrados.find( cartao => cartao.id === idCartaoDeCreditoSelecionado )
      if ( cartaoSelecioado ) {
        setCartaoExistente( cartaoSelecioado )
        setIdCartaoDeCreditoSelecionado( cartaoSelecioado.id )
      }
    } else {
      let cartao
      if ( !isEmptyObject( cartaoVigente ) ) {
        cartao = cartaoVigente
        setIdCartaoDeCreditoSelecionado( cartaoVigente.id )
      } else if (
        cartoesCadastrados &&
        cartoesCadastrados.length &&
        isEmptyObject( cartaoVigente )
      ) {
        cartao = cartoesCadastrados[ cartoesCadastrados.length - 1 ]
      }

      setCartaoExistente( cartao )
      setIdCartaoDeCreditoSelecionado( cartao.id )
    }
  }, [ cartaoVigente, idCartaoDeCreditoSelecionado ] )

  useEffect( () => {
    if ( idCartaoDeCreditoSelecionado !== ID_ADICIONAR_NOVO_CARTAO ) {
      setOpenFormulario( false )
    }
  }, [ idCartaoDeCreditoSelecionado ] )

  const salvarEnderecoSelecionado = id => {
    if ( id.optionChecked && id.optionChecked === ID_ADICIONAR_NOVO_CARTAO ) {
      setOpenFormulario( true )
    }

    setIdCartaoDeCreditoSelecionado( Number( id.optionChecked ) || id.optionChecked || id )
  }

  useEffect( () => {
    if ( openFormulario ) {
      if ( captcha === null ) {
        setValidCaptcha( false )
      } else {
        setValidCaptcha( true )
      }
    } else {
      setValidCaptcha( true )
      setCaptcha( null )
    }
  }, [ openFormulario, captcha ] )

  return (
    <>
      <WrapperEscolhaCartoesExistentes tema={ temaFluxo }>
        <RadioGroup
          defaultOption={ idCartaoDeCreditoSelecionado }
          group={ ID_RADIO_GROUP_PAGAMENTO_CARTAO }
          itemsDirection={ `${StyleGuide.isMobile() ? 'column' : 'row'}` }
          itemsPadding="0 0 20px 0"
          listDirection={ `${StyleGuide.isMobile() ? 'column' : 'row'}` }
          onChange={ salvarEnderecoSelecionado }
        >
          <RadioButton
            className="current-card"
            group={ ID_RADIO_GROUP_PAGAMENTO_CARTAO }
            id="pagamento-cartao"
            label={ TITULO_ESCOLHA_CARTAO_CREDITO_EXISTENTE }
            value={ cartaoExistente.id }
          >
            <WrapperCartaoCreditoVigente
              ativo={ idCartaoDeCreditoSelecionado === cartaoExistente.id }
              onClick={ () => salvarEnderecoSelecionado( cartaoExistente.id ) }
            >
              <CartaoCredito
                cartao={ cartaoExistente }
                corBorda={ temaFluxo }
                hover={ idCartaoDeCreditoSelecionado === cartaoExistente.id }
                selecionado={
                  idCartaoDeCreditoSelecionado === cartaoExistente.id
                }
              />
            </WrapperCartaoCreditoVigente>
          </RadioButton>

          <div className="all-cards">
            <LabelVerCartoesCadastrados
              setActiveModal={ () => setShowAllCreditCards( true ) }
              tema={ temaFluxo }
            />
          </div>

          <RadioButton
            className="new-card"
            group={ ID_RADIO_GROUP_PAGAMENTO_CARTAO }
            id="novo-pagamento-cartao"
            label={ ADICIONAR_NOVO_CARTAO }
            value={ ID_ADICIONAR_NOVO_CARTAO }
          >
            <div>
              {openFormulario ? (
                <CartaoCreditoForm
                  loading={ loading }
                  onConfirmar={ cartaoRetornado => setNovoCartaoCredito( cartaoRetornado ) }
                  tema={ temaFluxo }
                />
              ) : (
                <CardAdicionar
                  margin={ StyleGuide.isMobile() ? '0' : '0 0 25px' }
                  onClick={ () => {
                    salvarEnderecoSelecionado( ID_ADICIONAR_NOVO_CARTAO )
                    setOpenFormulario( true )
                  } }
                  titulo={ ADICIONAR_NOVO_CARTAO }
                  type="cartao"
                />
              )}
            </div>
          </RadioButton>
        </RadioGroup>
      </WrapperEscolhaCartoesExistentes>

      <SelecionaCartaoExistenteModal
        active={ showAllCreditCards }
        cartoesCadastrados={ cartoesCadastrados }
        closeModal={ () => setShowAllCreditCards( false ) }
        selecionaCartaoExistente={ selecionaCartaoExistente }
        setSelecionaCartaoExistente={ id => {
          setSelecionaCartaoExistente( id )
          setShowAllCreditCards( false )
          setIdCartaoDeCreditoSelecionado( id )
        } }
      />
    </>
  )
}

EscolhaCartoesExistentes.propTypes = {
  'idCartaoDeCreditoSelecionado': oneOfType( [ string, number ] ),
  'novoCartaoCredito': object.isRequired,
  'setIdCartaoDeCreditoSelecionado': func.isRequired,
  'setNovoCartaoCredito': func.isRequired
}

EscolhaCartoesExistentes.defaultProps = {
  'idCartaoDeCreditoSelecionado': null
}

export default EscolhaCartoesExistentes
